import { takeEvery, select, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'

// @ts-ignore
import { parseQuery } from 'helpers/urlHelper'
// @ts-ignore
import { showInfo } from 'store/entities/toastr/utils'
import { queryParams } from 'store/entities/router/selectors'

import { triggerReviewsSurveyProcess, fetchReviewsSurveyById } from '../actions'

export function* handleRunReviewsSurveyProcessSaga() {
  const queries = yield select(queryParams)
  let reviewsSurveyId
  try {
    reviewsSurveyId = queries.reviews_survey_id
    if (!reviewsSurveyId) {
      throw new Error()
    }
  } catch (e) {
    yield put(push('/login'))
    showInfo({ content: 'Token is invalid' })
  }
  yield put(fetchReviewsSurveyById(reviewsSurveyId))
}

export default function* runReviewsSurveyProcessSaga() {
  yield takeEvery(triggerReviewsSurveyProcess.toString(), handleRunReviewsSurveyProcessSaga)
}
